import React, { useEffect } from "react";
import RosieChat from "../components/RosieChat";

function RosiePage() {
    useEffect(() => {
        window.__rosieFullPage = true;
        return () => { window.__rosieFullPage = false; };
    }, []);
    return (
        <div style={{ height: "calc(100vh - 118px)", overflow: "hidden" }}>
            <RosieChat fullPage={ true } />
        </div>
    );
}

export default RosiePage;
